
import { Table, Icon, ButtonDropdown, Header, Button, SpaceBetween, Modal, Box, Checkbox, Input } from "@cloudscape-design/components";
import { useApi } from "../Api"
import { useState, useEffect } from "react";

export default function AccountAdmin(){

  const path = 'Accounts/';
  const Api = useApi();
  const [data, setData] = useState(null);
  const [dataLoading, setDataLoading] = useState(true);
  const [delAccount, setDelAccount] = useState(null);
  const [addModal, setAddModal] = useState(false);
  const [addEmail, setAddEmail] = useState(null);
  const [addAdmin, setAddAdmin] = useState(false);

  useEffect(() => {
    try{
      
      let rendered = true;
      Api.get( path, false ).then(object => {
        if (rendered) {
          setData(object);
          setDataLoading(false);
        }
      });
      return () => {
        rendered = false;
      };
    }
    catch{
      setData(null);
      setDataLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const columnDefinitions = [
      { id: "Email", header: "Email", cell: item => item.Email },
      { id: "Admin", header: "Admin", cell: item => item.Admin?<Icon name="key" />:null },
      {    
          id: 'actions',
          header: 'Actions',
          minWidth: 100,
          cell: item => (
            <ButtonDropdown
              items={[
                {
                  id: "delete",
                  text: "Delete",
                  iconName: "remove"
                },
                {
                  id: item.Admin ? "remove-admin" : "add-admin",
                  text: item.Admin ? "Remove from Admin" : "Add to Admin",
                  iconName: "key"
                }
              ]}
              variant="inline-icon"
              ariaLabel={`${item.Email} actions`}
              expandToViewport={true}
              onItemClick={({ detail }) => {
                  console.log(detail)
                  if(detail.id === "add-admin"){
                      updateUser(item.Username, true)
                  }else if (detail.id === "remove-admin"  ) {
                      updateUser(item.Username, false)
                  }else if (detail.id === "delete") {
                      setDelAccount(item)
                  }
              }}
            />
          )
        }
    ];
    
  

  const addUser = async(Email, Admin)=>{
    try{
      await Api.post( path, {Email, Admin} )
    }
    catch{}
      refresh();
  }


  const refresh = ()=>{
    try{
      if(!dataLoading){
        setDataLoading(true)
        Api.get( path, true ).then(object => {
            setData(object);
            setDataLoading(false);
        })
      }
    }
    catch{}
  }

  const updateUser = async(Username, Admin)=>{
    try{
      await Api.put( path, {Username, Admin} )
    }
    catch{}
    refresh();
  }

  const delUser = async(Username)=>{
    try{

      await Api.delete( path, {Username} )
    }  
    catch{} 
    refresh();
  }
/*
  const sleep = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms));
  }
      */

  return(
      <>
        <Modal
          visible={delAccount}
          onDismiss={()=>{setDelAccount(null)}}
          header='Delete User'
          closeAriaLabel="Close dialog"
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={()=>setDelAccount(null)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={()=>{delUser(delAccount.Username);setDelAccount(null)}}>
                  Delete
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
            Permanently delete user: {delAccount?delAccount.Email:null}
        </Modal>
        <Modal
          visible={addModal}
          onDismiss={()=>{setAddModal(null); setAddEmail(null);setAddAdmin(false)}}
          header='Add User'
          closeAriaLabel="Close dialog"
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={()=>{setAddModal(null); setAddEmail(null);setAddAdmin(false)}}>
                  Cancel
                </Button>
                <Button variant="primary" disabled={!addEmail} onClick={()=>{addUser(addEmail, addAdmin);setAddModal(null); setAddEmail(null);setAddAdmin(false);}}>
                  Add
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
          <SpaceBetween direction="horizontal" size="m" alignItems="center">  
            <Input 
              type="email"
              value={addEmail}
              onChange={({ detail }) => setAddEmail(detail.value)}
              placeholder="name@email.com"
            />
            <Checkbox checked={addAdmin} onChange={({ detail }) => setAddAdmin(detail.checked)} >Admin</Checkbox>
          </SpaceBetween>
        </Modal>
          <Table
              columnDefinitions={columnDefinitions}
              loading={dataLoading}
              loadingText="Loading Users"
              items={!dataLoading&&data?data.users:[]}
              header={
                  <Header
                      actions={
                      <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                        <Button
                          iconName="refresh"
                          ariaLabel="Refresh"
                          loadingText="Refreshing Accounts table"
                          loading={dataLoading}
                          onClick={refresh}
                        />
                        <Button disabled={dataLoading} onClick={()=>setAddModal(true)}>Add</Button>
                      </SpaceBetween>
                      }
                  >
                      {`Users: ${!dataLoading&&data&&data.users?data.users.length:''}`}
                  </Header>
              }
          />
      </>
  )
}